import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useStrava } from '../context/StravaContext'
import { useAuth } from '../context/AuthContext'

const StravaCallbackPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { handleOAuthCallback, isLoading, error } = useStrava()
  const { isAuthenticated } = useAuth()
  const callbackProcessed = useRef(false)

  useEffect(() => {
    // Prevent duplicate processing
    if (callbackProcessed.current) {
      return
    }

    // Redirect to admin if not authenticated
    if (!isAuthenticated) {
      navigate('/admin')
      return
    }

    const code = searchParams.get('code')
    const errorParam = searchParams.get('error')

    if (errorParam) {
      console.error('Strava OAuth error:', errorParam)
      navigate('/admin')
      return
    }

    if (code) {
      callbackProcessed.current = true
      handleOAuthCallback(code).then(() => {
        // Redirect back to admin after successful connection
        navigate('/admin')
      }).catch(() => {
        // Error handled by context, just redirect
        navigate('/admin')
      })
    } else {
      navigate('/admin')
    }
  }, [searchParams, navigate, handleOAuthCallback, isAuthenticated])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Connecting to Strava...
          </h2>
          {isLoading && (
            <div className="mt-4">
              <svg className="animate-spin mx-auto h-8 w-8 text-orange-600" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <p className="mt-2 text-sm text-gray-600">Processing your Strava authorization...</p>
            </div>
          )}
          {error && (
            <div className="mt-4 bg-red-50 border border-red-200 rounded-md p-4">
              <p className="text-sm text-red-600">{error}</p>
              <p className="text-xs text-gray-500 mt-1">Redirecting back to admin panel...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default StravaCallbackPage